import UtilsService from './utils-service';

export default UtilsService;